import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';

import {
  pickServiceGroupName,
  Subscription,
} from '@/types/subscriptions/subscription';
import { pages, formatRoute } from '@/settings/pages';
import { weekDayDateFormat, startDateFormat } from '@/utils/date';

import * as styles from './StyledItemGroup.module.scss';
import { ServiceName } from './ServiceName';

type Props = {
  children?: never;
  subscriptions: Subscription[];
};

export const StyledItemGroup: React.FC<Props> = (props) => {
  const { subscriptions } = props;
  const { t } = useTranslation();
  return (
    <div className={styles.group}>
      {subscriptions.map((subscription) => (
        <Link
          data-test={`subscription-list-item-${subscription.requestCode}`}
          className={styles.item}
          key={subscription.id}
          to={formatRoute(pages.subscription.detail, {
            requestCode: subscription.requestCode,
          })}
        >
          <div className={styles.innerWrapper}>
            <div className={styles.innerLeft}>
              <div className={styles.innerLeftHeader}>
                {pickServiceGroupName(subscription)}
                {subscription.isUpdatable && (
                  <span className={styles.innerLeftHeader_label}>
                    {t('ui.expression.changeable')}
                  </span>
                )}
              </div>
              <div className={styles.innerLeftBody}>
                <ServiceName subscription={subscription} />
              </div>
            </div>

            <div className={styles.innerRight}>
              <div>
                <span
                  className={styles.label}
                >{`${t('models.subscription.requestCode')}： `}</span>
                {subscription.requestCode}
              </div>

              <div className={styles.row_2_cal}>
                <div>
                  <span
                    className={styles.label}
                  >{`${t('models.subscription.appliedAt')}： `}</span>
                  {subscription.appliedAt &&
                    weekDayDateFormat({ date: subscription.appliedAt })}
                </div>

                <div className={styles.row_2_cal_right}>
                  <span
                    className={styles.label}
                  >{`${t('models.subscription.startsOn')}： `}</span>
                  {subscription.startsOn &&
                    startDateFormat({ date: subscription.startsOn })}
                </div>
              </div>

              <div className={styles.row_2_cal}>
                <div>
                  <span
                    className={styles.label}
                  >{`${t('models.subscription.users')}： `}</span>
                  {`${subscription.userCount}${t('ui.unit.studentNumber')}`}
                </div>

                <div className={styles.row_2_cal_right}>
                  {subscription.projectClass && (
                    <div>
                      <span
                        className={styles.label}
                      >{`${t('models.subscription.projectClass')}： `}</span>
                      {subscription.projectClass.name}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
};
